import dayjs from "dayjs";
import { I18nInterface } from "../ui/providers/I18nContext";

export function iso8601Date(date: Date): string {
  return date.toISOString().substring(0, 10);
}

export function formatDateForApi(dateToFormat: Date): Date {
  const localeDate = new Date(dateToFormat.getTime() - dateToFormat.getTimezoneOffset() * 60000);
  return new Date(localeDate.toISOString().slice(0, 10));
}

export function dateErrorTranslation(
  t: I18nInterface["t"],
  date: Date | null | undefined,
  options?: { min?: Date; max?: Date },
  local: "fr" | "en" = "fr",
): string | undefined {
  if (date === null || date === undefined) return undefined;
  if (!dayjs(date).isValid()) return t("yup.date.invalid");

  if (options === undefined) return undefined;

  const { min, max } = options;
  if (min && date < min) return t("yup.date.min", { min: min.toLocaleDateString(local) });
  if (max && date > max) return t("yup.date.max", { max: max.toLocaleDateString(local) });
  return undefined;
}
